import BadGateway from './BadGateway';

export default BadGateway;
